/**
 * This file takes care of global app side effects,
 * like clicking on add to cart and the cart modal being displayed
 */

import { signal } from '@preact/signals'

const shippingValue = signal(0)
const shippingCep = signal('')
const isRegionSouth = signal(false)
const isRegionSoutheast = signal(false)

const state = {
	shippingValue,
	isRegionSouth,
	isRegionSoutheast,
	shippingCep,
}

export const minicartUI = () => state
